import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip,ResponsiveContainer } from 'recharts';

// const data = [
//   { name: 'Global', value: 54 },
//   { name: 'GCC', value: 46 },
// ];

const COLORS = ['#2855A1', '#A15828'];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const textAnchor = x > cx ? 'start' : 'end';
  const labelX = x + (x > cx ? 8 : -8); // Adjust the label position

  return (
    <text x={labelX} y={y} fill="white" textAnchor={textAnchor} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomLegend = (props) => {
  const { payload } = props;
console.log(props);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {payload.map((entry, index) => (
        <div key={`legend-${index}`} style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
          <div style={{ backgroundColor: entry.color, width: '10px', height: '10px', borderRadius: '50%', marginRight: '15px' }} />
          <span>{entry?.payload?.CountryName}</span>
        </div>
      ))}
    </div>
  );
};

export default class Employergraph extends PureComponent {
  render() {
    const { EmployerAvailability } = this.props;
    console.log(EmployerAvailability);
    return (
      <>
      {EmployerAvailability && (
        <ResponsiveContainer width="100%" height={350} style={{ marginBottom: '15px' }}>
        <PieChart width={250} height={350}>
          <Pie 
            data={EmployerAvailability}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={130}
            fill="#8884d8"
            dataKey="TotalCount"
          >
            {EmployerAvailability.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend content={<CustomLegend />} align="center" verticalAlign="bottom" height={36} />
          <Tooltip formatter={(value) => `${value}%`} />
        </PieChart>
      </ResponsiveContainer>
      )}
      </>
    );
  }
}
